<div class="download-bg" aria-hidden="true"></div>

@if (showInstagramBrowserNotice) {
<div class="instagram-notice-backdrop" role="presentation">
  <section
    class="instagram-notice"
    role="dialog"
    aria-modal="true"
    aria-labelledby="instagram-notice-title"
  >
    <button
      class="instagram-notice-close"
      type="button"
      aria-label="Fermer"
      (click)="closeInstagramBrowserNotice()"
    >
      ×
    </button>
    <span class="instagram-notice-icon" aria-hidden="true">↗</span>
    <h2 id="instagram-notice-title">Ouvrir SALOONS hors d’Instagram</h2>
    <p>
      Instagram bloque parfois l’accès à l’App Store. Ouvre le lien dans ton navigateur pour
      télécharger l’application.
    </p>
    <button class="instagram-notice-action" type="button" (click)="openAppStoreOutsideInstagram()">
      Continuer vers l’App Store
    </button>
    <small>
      Si rien ne se passe, touche les <strong>•••</strong> en haut à droite puis
      <strong>Ouvrir dans le navigateur</strong>.
    </small>
  </section>
</div>
}

<div class="download-page">
  <app-public-header />

  <main class="download-main">
    <section class="hero-card">
      <div class="hero-copy">
        <p class="eyebrow">Application mobile</p>
        <h1>Télécharge SAL<span>OO</span>NS</h1>
        <p class="lead">
          Entre dans les saloons autour de toi, découvre les personnes présentes dans les mêmes
          lieux et laisse la rencontre commencer dans le réel.
        </p>

        <div class="store-actions app-store-badges" aria-label="Liens de téléchargement">
          <a
            class="store-badge apple"
            [href]="appStoreUrl"
            rel="noopener"
            (click)="handleAppStoreClick($event)"
          >
            <svg viewBox="0 0 196 54" role="img" aria-label="Télécharger dans l’App Store">
              <rect width="196" height="54" rx="10" fill="#050505" />
              <path
                fill="#fff"
                d="M40.2 26.1c0-4.3 3.6-6.4 3.8-6.5-2-3-5.2-3.4-6.3-3.4-2.7-.3-5.2 1.6-6.6 1.6s-3.5-1.6-5.7-1.5c-3 .1-5.7 1.7-7.2 4.3-3.1 5.3-.8 13.2 2.2 17.5 1.5 2.1 3.2 4.5 5.5 4.4 2.2-.1 3.1-1.4 5.7-1.4s3.4 1.4 5.7 1.4c2.4 0 3.9-2.2 5.3-4.3 1.7-2.5 2.4-4.8 2.4-5-.1 0-4.8-1.8-4.8-7.1Zm-4.3-12.7c1.2-1.5 2-3.5 1.8-5.5-1.7.1-3.9 1.2-5.1 2.6-1.1 1.3-2.1 3.4-1.8 5.4 1.9.1 3.9-1 5.1-2.5Z"
              />
              <text
                x="58"
                y="21"
                fill="#fff"
                font-family="Arial, Helvetica, sans-serif"
                font-size="10"
                font-weight="400"
              >
                Télécharger dans
              </text>
              <text
                x="58"
                y="39"
                fill="#fff"
                font-family="Arial, Helvetica, sans-serif"
                font-size="21"
                font-weight="700"
              >
                App Store
              </text>
            </svg>
          </a>

          <a class="store-badge google" [href]="googlePlayUrl" target="_blank" rel="noopener">
            <svg viewBox="0 0 196 54" role="img" aria-label="Disponible sur Google Play">
              <rect width="196" height="54" rx="10" fill="#050505" />
              <path
                fill="#00A0FF"
                d="M20 12.3c-.4.5-.6 1.2-.6 2v25.4c0 .8.2 1.5.6 2l14.5-14.6L20 12.3Z"
              />
              <path fill="#00F076" d="m39.1 22.4-4.6 4.7L20 12.3c.7-.8 1.9-.9 3.2-.2l15.9 10.3Z" />
              <path
                fill="#FFCE00"
                d="m39.1 31.6-15.9 10.3c-1.3.7-2.5.6-3.2-.2l14.5-14.6 4.6 4.5Z"
              />
              <path
                fill="#FF3A44"
                d="m45 26.1-5.9-3.7-4.6 4.7 4.6 4.5 5.9-3.7c1.2-.7 1.2-1.1 0-1.8Z"
              />
              <text
                x="58"
                y="21"
                fill="#fff"
                font-family="Arial, Helvetica, sans-serif"
                font-size="10"
                font-weight="400"
              >
                Disponible sur
              </text>
              <text
                x="58"
                y="39"
                fill="#fff"
                font-family="Arial, Helvetica, sans-serif"
                font-size="20"
                font-weight="700"
              >
                Google Play
              </text>
            </svg>
          </a>
        </div>

        <p class="availability-note"><span></span> Disponible maintenant sur iPhone et Android.</p>
      </div>

      <div class="phone-preview">
        <div class="phone-shell">
          <span class="phone-speaker" aria-hidden="true"></span>
          <img
            src="assets/images/app-screens/saloons-match.png"
            alt="Écran de clin d'œil réciproque dans l'application Saloons"
          />
        </div>
      </div>
    </section>
  </main>

  <footer class="download-footer">
    <span>© {{ currentYear }} SALOONS</span>
    <a routerLink="/politique-confidentialite">Confidentialité</a>
    <a routerLink="/cgu">CGU</a>
  </footer>
</div>
